import jquery from "jquery"

function toggleFuturePaymentButton(selectElement) {
  const targetId = selectElement.dataset.futurePaymentsTarget;
  if (!targetId) {
    return;
  }

  const button = document.getElementById(targetId);
  if (!button) {
    return;
  }

  if (selectElement.value !== "-1") {
    button.classList.remove("d-none");
  } else {
    button.classList.add("d-none");
  }
}

jquery(document).on("change", "select[data-future-payments-target]", function () {
  toggleFuturePaymentButton(this);
});

jquery(function () {
  document.querySelectorAll("select[data-future-payments-target]").forEach((selectElement) => {
    toggleFuturePaymentButton(selectElement);
  });
});